import NotFound404 from '@dolpheen/images/NotFound404'
import { Button as MuiButton, styled } from '@mui/material'

export { Container, Header, IconContainer, InnerContainer, Root } from '@ui/StatusPage/styles'

// Kept local: ForbiddenPage's button has no padding of its own.
export const Button = styled(MuiButton)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: 20,
}))

export const NotFound404Icon = styled(NotFound404)({
  height: '20rem',
  width: '20rem',
})
